import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const appRoutes: RouteConfig = {
  path: '/appSoftware',
  component: Layout,
  meta: {
    title: 'appSoftware',
    icon: 'example',
    redirect: '/appSoftware/appSoftware',
    // alwaysShow: true 
  },
  children: [
    {
      path: 'appSoftware',
      component: () => import('@/views/app/index.vue'),
      meta: {
        // title: 'adminList',
        title: 'appSoftware',
        icon: 'example',
        activeMenu: '/appSoftware/appSoftware',
      }
    }
  ]

}

export default appRoutes